import { practice } from "../../data/practice";
import { organizationId } from "./practiceEntity";
import { buildSeoPageGraph } from "./pageGraph";
import { PATH_NETZVERBUND_SCHWARZWALD } from "../../utils/constants";

const NETZVERBUND_DESCRIPTION =
  "Regionales Versorgungsnetzwerk für Menschen mit komplexen psychischen Erkrankungen im Schwarzwald, zentral koordiniert über die ERGOTHERAPIE UND ZEIT(T)RÄUME in Rottweil.";

export const netzverbundContact = practice.netzverbundContact;

export function buildNetzverbundPageGraph() {
  const base = buildSeoPageGraph(PATH_NETZVERBUND_SCHWARZWALD, "netzverbundSchwarzwald", {
    description: NETZVERBUND_DESCRIPTION,
  });

  const netzOrg = {
    "@type": "MedicalOrganization",
    "@id": `${practice.baseUrl}${PATH_NETZVERBUND_SCHWARZWALD}#organization`,
    name: "Netzverbund Schwarzwald",
    description: NETZVERBUND_DESCRIPTION,
    url: `${practice.baseUrl}${PATH_NETZVERBUND_SCHWARZWALD}`,
    telephone: netzverbundContact.phone,
    email: netzverbundContact.email,
    areaServed: {
      "@type": "AdministrativeArea",
      name: "Schwarzwald",
    },
    memberOf: {
      "@id": organizationId,
    },
  };

  base["@graph"].push(netzOrg);
  return base;
}
